import { all, call, put, takeLatest } from 'redux-saga/effects';
import * as dashboardApi from 'api/dashboardApi';
import { OutdoorConditionsPayload } from 'views/dashboard/outdoor/types';
import { fetchOutdoorConditionsFailure, fetchOutdoorConditionsSuccess } from 'redux/actions/outdoorConditionsActions';
import * as actionTypes from '../actionTypes';

export function* fetchOutdoorConditionsSaga() {
    try {
        const response: OutdoorConditionsPayload = yield call(dashboardApi.getOutdoorConditions);
        yield put(fetchOutdoorConditionsSuccess(response));
    } catch (e: any) {
        yield put(
            fetchOutdoorConditionsFailure({
                error: e.message,
            }),
        );
    }
}

function* outdoorConditionsSaga() {
    yield all([takeLatest(actionTypes.FETCH_OUTDOOR_CONDITIONS_REQUEST, fetchOutdoorConditionsSaga)]);
}

export default outdoorConditionsSaga;
